export function sanitizeRelativeRedirectTarget(target?: string | null) {
	if (!target || !target.startsWith("/") || target.startsWith("//")) {
		return null;
	}

	try {
		const url = new URL(target, "https://studyos.invalid");
		return `${url.pathname}${url.search}${url.hash}`;
	} catch {
		return null;
	}
}

export function resolveAuthRedirectTarget(redirectTo?: string | null) {
	return sanitizeRelativeRedirectTarget(redirectTo) ?? "/";
}
